<template>
    <div>
        <v-dialog v-model="dialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
            <invalidate-password-form :value="userId" @cancel="dialog = false" @save="onInvalidation" />
        </v-dialog>
        <table-base :filter="customFilter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="memberForm" :refresh-key="refreshKey" :show-expand="$route.name == 'members'" :has-member-import="true" :set-api-data="setApiData">
            <template v-slot:expand="{ item, refreshKey }">
                <component :is="member" v-if="$route.name == 'members'" :item-id="item.id" :refresh-key="refreshKey" :filter="customFilter" />
            </template>
            <template v-slot:tabs>
                <v-row>
                    <v-col>
                        <v-btn-toggle mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                            <v-btn @click="toggleTabs(false)"> Active </v-btn>
                            <v-btn @click="toggleTabs(true)"> Inactive </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:buttons="{ item }">
                <v-btn @click="resendEmail(item.id)"><v-icon>mdi-email</v-icon></v-btn>
                <v-btn v-if="!displayInactive" @click="invalidatePassword(item.id)"><v-icon>mdi-key-remove</v-icon></v-btn>
            </template>
        </table-base>
    </div>
</template>

<script>
    import axios from "axios"

    export default {
        props: [
            'filter'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
            invalidatePasswordForm: () => import('@/forms/InvalidatePasswordForm')
        },
        data() {
            return {
                memberForm: () => import('../forms/MemberForm'),
                member: () => import('../editViews/Member'),
                headers: [
                    { text: 'Email Address', value: 'emailAddress' },
                    { text: 'Name', value: 'name' },
                    { text: 'Membership Number', value: 'membershipNumber' },
                    { text: 'Is B-TRACE', value: 'isBtrace' },
                    { text: 'First Audit On', value: 'firstAuditOn', format: this.formatDate },
                    { text: 'Code of Practice Declaration', value: 'codeOfPracticeDeclarationFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: [],
                    files: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "emailAddress", direction: "ascending" },
                    { column: "membershipNumber", direction: "ascending" }
                ],
                itemsField: 'members',
                editPageName: 'member',
                apiMethod: 'Members',
                claimName: 'Members',
                formTitle: 'Member',
                excelTitle: 'Members',
                hasEditPage: false,
                userId: null,
                dialog: false,
                refreshKey: 0,
                displayInactive: false
            }
        },
        methods: {
            async resendEmail(id) {
                let userId = (await axios.get("/api/Members/GetUserId/" + id)).data;
                await axios.get("/api/Users/ResendEmail/" + userId);
            },
            async invalidatePassword(id) {
                this.userId = (await axios.get("/api/Members/GetUserId/" + id)).data;
                this.dialog = true;
            },
            onInvalidation() {
                this.dialog = false;
                this.refreshKey++;
            },
            async toggleTabs(displayInactive) {
                this.displayInactive = displayInactive;
                this.refreshKey += 1;
            },
            setApiData(data) {
                this.$set(this.apiData, 'files', data.files);
                this.$set(this.apiData, 'items', data.items.filter(i => this.displayInactive ? i.isInactive : !i.isInactive));
            }
        },
        computed: {
            customFilter() {
                var customFilter = { ...this.filter };
                if (!this.canRead("MemberAuditReminderManagement")) {
                    customFilter.firstAuditOn = null;
                }
                return customFilter;
            }
        }
    };
</script>
